import { Extension } from "@tiptap/core";
import { editLink } from "./commands";

export const FormatKeymap = Extension.create({
  name: "klarityFormatKeys",
  addKeyboardShortcuts() {
    return {
      "Mod-b": ({ editor }) => editor.commands.toggleMark("bold"),
      "Mod-i": ({ editor }) => editor.commands.toggleMark("italic"),
      "Mod-e": ({ editor }) => editor.commands.toggleMark("code"),
      "Mod-k": ({ editor }) => {
        void editLink(editor);
        return true;
      },
      "Mod-Alt-0": ({ editor }) => editor.commands.setNode("paragraph"),
      "Mod-Alt-1": ({ editor }) => editor.commands.setNode("heading", { level: 1, number: true }),
      "Mod-Alt-2": ({ editor }) => editor.commands.setNode("heading", { level: 2, number: true }),
    };
  },
});
